import { Navigation as PolarisNavigation } from '@shopify/polaris'
import {
  HomeMinor,
  ConversationMinor,
  CustomersMinor,
  AnalyticsMinor,
  SettingsMinor,
  LogOutMinor,
  CirclePlusMinor,
  AppsMinor,
  ViewMinor,
  CircleTickMinor,
  CashDollarMinor,
  ProductsMinor,
  StarFilledMinor,
  TeamMajor
} from '@shopify/polaris-icons'
import { useLocation, useNavigate } from 'react-router-dom'

import { useAuth } from '@/contexts/AuthContext'

export function Navigation() {
  const location = useLocation()
  const navigate = useNavigate()
  const { logout, capabilities } = useAuth()

  const navigationItems = [
    {
      label: 'Dashboard',
      icon: HomeMinor,
      url: '/dashboard',
      selected: location.pathname === '/dashboard'
    },
    {
      label: 'Conversations',
      icon: ConversationMinor,
      url: '/conversations',
      selected: location.pathname.startsWith('/conversations')
    },
    {
      label: 'Customers',
      icon: CustomersMinor,
      url: '/customers',
      selected: location.pathname === '/customers'
    },
    {
      label: 'Team',
      icon: TeamMajor,
      url: '/team',
      selected: location.pathname === '/team'
    },
    {
      label: 'Interactive Messages',
      icon: AppsMinor,
      url: '/interactive',
      selected: location.pathname.startsWith('/interactive')
    },
    {
      label: 'Workflows',
      icon: CirclePlusMinor,
      url: '/workflows',
      selected: location.pathname.startsWith('/workflows')
    },
    {
      label: 'QR Codes',
      icon: ViewMinor,
      url: '/qr-codes',
      selected: location.pathname.startsWith('/qr-codes')
    },
    {
      label: 'Verification',
      icon: CircleTickMinor,
      url: '/verification',
      selected: location.pathname.startsWith('/verification')
    },
    {
      label: 'COD Management',
      icon: CashDollarMinor,
      url: '/cod',
      selected: location.pathname.startsWith('/cod'),
      capability: 'cod'
    },
    {
      label: 'Catalog',
      icon: ProductsMinor,
      url: '/catalog',
      selected: location.pathname.startsWith('/catalog'),
      capability: 'catalog'
    },
    {
      label: 'Reviews',
      icon: StarFilledMinor,
      url: '/reviews',
      selected: location.pathname.startsWith('/reviews'),
      capability: 'reviews'
    },
    {
      label: 'Team Routing',
      icon: TeamMajor,
      url: '/team-routing',
      selected: location.pathname.startsWith('/team-routing')
    },
    {
      label: 'Analytics',
      icon: AnalyticsMinor,
      url: '/analytics',
      selected: location.pathname === '/analytics'
    },
    {
      label: 'Settings',
      icon: SettingsMinor,
      url: '/settings',
      selected: location.pathname === '/settings'
    }
  ]

  const handleNavigation = (item: any) => {
    navigate(item.url)
  }

  // Hide commerce-only items for workspaces that don't have that capability
  // (e.g. STANDALONE sales-team workspaces).
  const visibleItems = navigationItems.filter(item => {
    const cap = (item as any).capability as keyof typeof capabilities | undefined
    return !cap || capabilities[cap]
  })

  return (
    <PolarisNavigation location={location.pathname}>
      <PolarisNavigation.Section
        items={visibleItems.map(item => ({
          ...item,
          onClick: () => handleNavigation(item)
        }))}
      />
      
      <PolarisNavigation.Section
        separator
        title="Account"
        items={[
          {
            label: 'Logout',
            icon: LogOutMinor,
            onClick: logout
          }
        ]}
      />
    </PolarisNavigation>
  )
}